/**
 * @fileoverview Audit Log table layout constants.
 * @description The one grid template the table's header and every row share, so their columns line
 * up, and the table's minimum width before it scrolls sideways. Written out as full literal class
 * names (not assembled from pieces) so Tailwind sees them.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const AUDIT_TABLE_GRID_CLASS = 'grid grid-cols-[1.4fr_1.5fr_2.1fr_1.7fr_1fr_0.9fr]'

export const AUDIT_TABLE_MIN_WIDTH_CLASS = 'min-w-[1040px]'
